// =====================================================================
// filesCommon — SSOT helpers shared between Admin Project Files page
// and the Client Portal Files page.  Lifted from B3aPages.jsx in
// Dispatch 5 Phase F (2026-11-05); no behaviour change to admin.
// =====================================================================
import React from "react";
import { FileText, Image as ImageIcon } from "lucide-react";

export const WS_NAMES = {
    1: "Initial Enquiry + Brief Development",
    2: "Project Feasibility",
    3: "Concept Design",
    4: "Developed + Technical Design",
    5: "Pre-Construction",
    6: "Construction",
    7: "Post-Construction",
};
export const WS_LIST = [1, 2, 3, 4, 5, 6, 7];

export const SOURCE_ORIGIN_LABELS = {
    "admin_upload":               "Admin upload",
    "executed_agreement":         "Executed agreement",
    "executed_contract":          "Executed contract",
    "executed_change_instrument": "Executed change instrument",
    "rfi_response":               "Client RFI",
    "client_response":            "Client portal upload",
    "feasibility_image":          "Feasibility image",
    "feasibility_supporting":     "Feasibility supporting",
    "deliverable":                "Deliverable",
};

export const sourceOriginLabel = (k) =>
    (k && SOURCE_ORIGIN_LABELS[k]) || (k ? k : "—");

// Mirror of backend BATCH_DOWNLOAD_MAX_BYTES (stage5_b3_files.py).
export const BATCH_DOWNLOAD_MAX_BYTES = 500 * 1024 * 1024;

export function fmt(dt) {
    try { return new Date(dt).toLocaleString("en-GB"); }
    catch { return dt || "—"; }
}

export function bytes(n) {
    if (!n && n !== 0) return "—";
    const u = ["B", "KB", "MB", "GB"];
    let i = 0, v = n;
    while (v > 1024 && i < u.length - 1) { v /= 1024; i++; }
    return `${v.toFixed(v < 10 ? 1 : 0)} ${u[i]}`;
}

export function TypeIcon({ mime }) {
    if ((mime || "").startsWith("image/"))
        return <ImageIcon className="w-4 h-4 text-[#666]" />;
    return <FileText className="w-4 h-4 text-[#666]" />;
}

// Dispatch 3 Phase I — Filetype display "PDF (3.36 MB)".
export function fileTypeDisplay(file, cur) {
    const mime = cur?.mime_type || file.content_type || "";
    const sz = cur?.size ?? file.size;
    const fname = cur?.filename || file.filename || file.name || "";
    const ext = fname.includes(".")
        ? fname.split(".").pop().toUpperCase()
        : (mime.split("/").pop() || "").toUpperCase();
    const left = ext || "FILE";
    const right = (sz || sz === 0) ? bytes(sz) : null;
    return right ? `${left} (${right})` : left;
}
